module.exports = __webpack_public_path__ + "img/IRISA.2682eee.png";